import React, { useEffect, useState } from 'react';
import { Container, Alert, Toast, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import api from '../seller-apis/api';
import { fetchansQA, fetchQA, fetchunansQA } from '../seller-apis/apidataField';
import PaginationCom from './common/Pagination';
import Qa_Card from './common/QaCard';
import Myalert from './common/Myalert';
import Header from './common/Header';
import './ques-ans.css';

var userEmail = localStorage.getItem('Email');
function Question_answer() {


  const history = useHistory();  // Size states

  const [currView, setcurrView] = useState();


  const [qaList, setqaList] = useState([]);

  // For desktop questions

  const [answQ,setanswQ] = useState([]);
  const [unanswQ, setunanswQ] = useState([]);

  // Pagination related

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalrecords, setTotalRecords] = useState();
  const [anstotalRec, setanstotalRec] = useState();
  const [unanstotalRec, setunanstotalRec] = useState();

  //  Loader

  const [ennewloader, setennewloader] = useState();

  // Alert related states

  const [alertshow, setalertShow] = useState(false)
  const [alertMessage, setalertMessage] = useState();
  const [alertType, setalertType] = useState();

  // Toast

  const [showToast, setshowToast] = useState(false)
  const [ToastMsg, setToastMsg] = useState();


  useEffect(() => {
    // history.block();

    setennewloader("none")
    let data = {
      "pageNo": "1",
      "email":"neerajthapliyal4@gmail.com"
    }
    let size = window.innerWidth;
    // if (size > 768) {
      if(size>768){
        setcurrView('laptop')
      }
      else{
        setcurrView('mobile');
      }
      api.QandA.fetchQA(fetchansQA(data)).then((res)=>{
        console.log(res)
        setanswQ(res.data)
        setanstotalRec(res.totalRecords)
      })
      api.QandA.fetchQA(fetchunansQA(data)).then((res)=>{
        console.log(res)
        setunanswQ(res.data)
        setunanstotalRec(res.totalRecords)
      })
  
    api.QandA.fetchQA(fetchQA(data)).then((res) => {
      console.log(res)
      setqaList(res.data)
      setTotalRecords(res.totalRecords)
    }).catch(err => console.log(err))
  }, [])

  // Callback answer

  function callbackAnswer(data) {
    if (data.answer === undefined) {
      setshowToast(true)
      setToastMsg("Answer cannot be empty!")
    }
    else{
      let postdata = {
        "questionId": data.qid,
        "answer": data.answer
      }
      api.QandA.answerQuestions(postdata).then((res) => {
        if (res.message === "Record updated ") {
          let d = {
            "pageNo": selectedPage
          }
          setalertMessage("Answer updated");
          setalertShow(true);
          setalertType("lightgreen");

          setTimeout(() => {
            setalertShow(false)
          }, 3500);
          api.QandA.fetchQA(fetchQA(d)).then((res) => {
            setqaList(res.data)
            setTotalRecords(res.totalRecords)
          }).catch(err => console.log(err))
          api.QandA.fetchQA(fetchansQA(data)).then((res)=>{
            console.log(res)
            setanswQ(res.data)
            setanstotalRec(res.totalRecords)
          })
          api.QandA.fetchQA(fetchunansQA(data)).then((res)=>{
            console.log(res)
            setunanswQ(res.data)
            setunanstotalRec(res.totalRecords)
          })
      
        }
        else {
          setalertMessage("Failed");
          setalertShow(true);
          setalertType("red");

          setTimeout(() => {
            setalertShow(false)
          }, 3500);
        }
      }).catch(err => console.log(err))
    }
  }



  //  Control view acc to size
  function handleResize() {
    if (window.innerWidth > 768) {
     window.location.assign('/q&a')
    }
    else {
      window.location.assign('q&a')
      setcurrView('mobile');
    }

  }


  window.addEventListener('resize', handleResize);

  // Pagination 

  function paginate(data) {
    let outerdiv = document.getElementById("outer");
    let loaderDiv = document.getElementById("enNewLoader");
    outerdiv.classList.add("div-bk");
    loaderDiv.classList.add("loader-bt");
    setennewloader("block")
    let filterData = {
      "pageNo": data.number,
      "email":"neerajthapliyal4@gmail.com"
    }
    setSelectedPage(data.number)
    if(data.comp === "q&a"){
      api.QandA.fetchQA(fetchQA(filterData)).then((res) => {
        setqaList(res.data)
        setennewloader("none")
        outerdiv.classList.remove("div-bk");
        loaderDiv.classList.remove("loader-bt");
      }).catch(err => console.log(err))
    }
    else if(data.comp === "ansq&a"){
      api.QandA.fetchQA(fetchansQA(filterData)).then((res)=>{
        setanswQ(res.data)
        setennewloader("none")
        outerdiv.classList.remove("div-bk");
        loaderDiv.classList.remove("loader-bt");
      }).catch(err=>console.log(err))
    }
    else{
      api.QandA.fetchQA(fetchunansQA(filterData)).then((res)=>{
        setunanswQ(res.data)
        setennewloader("none")
        outerdiv.classList.remove("div-bk");
        loaderDiv.classList.remove("loader-bt");
    }).catch(err=>console.log(err))
  }
}
  // -----------------for Mobile--------------//
  if (currView === "mobile") {
    return (
      <div id="outer">
        {alertshow === true ?
          <Alert variant="success" className="Myalert" style={{ "backgroundColor": alertType }} onClose={() => setalertShow(false)} dismissible>
            <Myalert
              message={alertMessage}
            />
          </Alert> : <></>
        }

        <div className="page-bg">
          <section>
            <div className="py-3 back-head-nospc my-3 bg-theme text-white"><span onClick={() =>history.push('/home')}><i className="fa fa-arrow-left mx-3"></i> </span><span className="f-600">Question and Answer </span></div>

            <Container>
              {qaList.length > 0 && qaList.map((item, index) => {
                let baseImg;
                let isAns = "false";
                let ansIndex;
                item.productId.images.map((item) => {
                  if (item.baseImage === true) {
                    if (item.image.startsWith("products")) {
                      baseImg = item.image;
                    }
                    else {
                      let img = item.image.substr("41")
                      baseImg = img;
                    }
                  }
                })
                if (item.answers.length > 0) {
                  item.answers.map((rec,ind)=>{
                    if(rec.email === "neerajthapliyal4@gmail.com"){
                      console.log(item,index)
                      isAns = "true"
                      ansIndex = ind;
                    }
                  })
                }
                if(isAns === "true"){
                  return (
                    <>
                      <Qa_Card
                        id={index}
                        img={baseImg}
                        productName={item.productId.productName}
                        SKU={item.productId.SKU}
                        question={item.question}
                        answer={item.answers[ansIndex].answer}
                      />
                    </>
                  )
                }
                else {
                  return (
                    <>
                      <Qa_Card
                        img={baseImg}
                        id={index}
                        Qid={item._id}
                        productName={item.productId.productName}
                        SKU={item.productId.SKU}
                        question={item.question}
                        callbackAnswer={callbackAnswer}
                      />
                    </>
                  )
                }

              })}

            </Container>
          </section>


          <div class="d-flex justify-content-center" id="enNewLoader" >
            <div class="spinner-border" role="status" style={{ "display": ennewloader }}>
              <span class="sr-only"></span>
            </div>
          </div>

          <PaginationCom
            number={totalrecords}
            paginate={paginate}
            comp="q&a"
          />
        </div>

        {/* Toast */}
        <Toast show={showToast} className="ToastHome" onClose={() => setshowToast(false)}>
          <Toast.Header>
            <strong className="me-auto">Message</strong>
          </Toast.Header>
          <Toast.Body>{ToastMsg}</Toast.Body>
        </Toast>
      </div>
    )

  }
      // -----------------for Desktop--------------//
  else {
    return (
      <>
      <div id="outer">
        {alertshow === true ?
          <Alert variant="success" className="Myalert" style={{ "backgroundColor": alertType }} onClose={() => setalertShow(false)} dismissible>
            <Myalert
              message={alertMessage}
            />
          </Alert> : <></>
        }
        <div className="container">
          <div class="tab-frame gry-line">
            <input type="radio" defaultChecked name="tab"  className="tab-input" id="tab1" />
            <label for="tab1" className="w-50 tab-label-input">New Questions</label>

            <input type="radio" name="tab" id="tab2" className="tab-input" />
            <label for="tab2" className="w-50  tab-label-input">Previously Answered</label>



            <div class="tab">
              {/* Card */}
              {unanswQ.length>0 && unanswQ.map((item,index)=>{
                 let baseImg;
                 item.productId.images.map((item) => {
                  if (item.baseImage === true) {
                    if (item.image.startsWith("products")) {
                      baseImg = item.image;
                    }
                    else {
                      let img = item.image.substr("41")
                      baseImg = img;
                    }
                  }
                })
                return(
                  <>
                   <div>
                <Row>
                  <div className="col-3">
                    <img src={"https://s3.toolsvilla.com/"+baseImg} className="img-fit" alt="img"></img>

                  </div>

                  <div className="col-5 l-h20">
                    <p className="theme-col f-600 mb-0 fs-17">{item.productId.productName}</p>
                    <span className="theme-col ">Quantity: 2</span>
                    <h6 className="f-600 gry text-center fs-16">Customer's Questions</h6>
                    <p className="theme-col f-700 fs-19">{item.question} ?</p>

                  </div>


                  <div className="col-4">
              

                  </div>
                </Row>
                <div className="gry-line-single w-100 mt-1"></div>
              </div>
                  </>
                )
              })}
             
          <div class="d-flex justify-content-center" id="enNewLoader" >
            <div class="spinner-border" role="status" style={{ "display": ennewloader }}>
              <span class="sr-only"></span>
            </div>
          </div>
            
          <PaginationCom
            number={unanstotalRec}
            paginate={paginate}
            comp="unansq&a"
          />


            </div>
            <div class="tab">

              {/* Card */}
              {answQ.length>0 && answQ.map((item,index)=>{
                  let baseImg;
                  let ans;
                 item.productId.images.map((item) => {
                  if (item.baseImage === true) {
                    if (item.image.startsWith("products")) {
                      baseImg = item.image;
                    }
                    else {
                      let img = item.image.substr("41")
                      baseImg = img;
                    }
                  }
                })
                if (item.answers.length > 0) {
                  item.answers.map((rec,ind)=>{
                    if(rec.email === "neerajthapliyal4@gmail.com"){
                      console.log(item,index)
                      ans = rec.answer
                    }
                  })
                }
                return(
                  <>
                  <div>
                  <Row>
                    <div className="col-2">
                      <img src={"https://s3.toolsvilla.com/"+baseImg} className="img-fit " alt="img"></img>
    
                    </div>
    
                    <div className="col-10">
                      <div className="col-7 ">
                        <p className="theme-col f-600 mb-0 fs-17 l-h-1">{item.productId.productName}</p>
                      </div>
                      <Row>
                        <div className="col-3">
                          <span className="theme-col mb-0">Quantity: 2</span>
                        </div>
                        <div className="col-8">
                          <div className="page-bg1 text-center px-2 py-2 corner">
                            <h6 className="f-600 gry r fs-16 mb-0">Customer's Questions</h6>
                            <p className="gry f-500 fs-18 mb-0">{item.question} ?</p>
                            <h6 className="f-600 gry text-center gry fs-16 mb-0">Your Answer</h6>
                            {item.answers.length>0 ?  <p className="gry f-500 fs-18 mb-0">{ans}</p>:<></>}
                      
                          </div>
    
                        </div>
                      </Row>
    
    
                    </div>
    
    
    
                  </Row>
                  <div className="gry-line-single w-100 mt-3"></div>
    
                </div>
              
                </>
                )
              })}
            
          <PaginationCom
            number={anstotalRec}
            paginate={paginate}
            comp="ansq&a"
          />
          
        {/* Toast */}
        <Toast show={showToast} className="ToastHome" onClose={() => setshowToast(false)}>
          <Toast.Header>
            <strong className="me-auto">Message</strong>
          </Toast.Header>
          <Toast.Body>{ToastMsg}</Toast.Body>
        </Toast>
            </div>
            </div>
          </div>
     
</div>
      </>



    )
  }




}




export default Question_answer;